export enum CdmAnalyticsEvents {
	// Add devices dialog
	AddDevicesDialogLaunched = 'add_devices_dialog_launched',
	AddDevicesDialogCancelled = 'add_devices_dialog_cancelled',
	AddDevicesDialogDevicesAdded = 'add_devices_dialog_devices_added',

	// Device actions
	DeviceAction = 'device_action',
	DeviceActionCancelled = 'device_action_cancelled',

	// Firmware update
	FirmwareUpdateDialogLaunched = 'firmware_update_dialog_launched',
	FirmwareUpdateDialogCancelled = 'firmware_update_dialog_cancelled',
	FirmwareUpdateSubmitted = 'firmware_update_submitted',
	FirmwareUpdateRemoved = 'firmware_update_removed',

	// Manage gateways
	ManagedGatewaysDialogLaunched = 'managed_gateways_dialog_launched',
	ManagedGatewaysDialogCancelled = 'managed_gateways_dialog_cancelled',
	ManagedGatewaysDevicesAdded = 'managed_gateways_devices_added',
	ManagedGatewaysDevicesRemoved = 'managed_gateways_devices_removed',
	ManagedGatewaysDevicesTransferred = 'managed_gateways_devices_transferred',

	// Scheduled jobs
	ScheduledJobAction = 'scheduled_job_action',
	ScheduledJobListRefreshed = 'scheduled_job_list_refreshed',

	// Tables
	TableColumnSettingsChanged = 'table_column_settings_changed',
	TableExported = 'table_exported'
}
